import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { SearchFormComponent } from './pages/search-form/search-form.component';
import { SearchResultComponent } from './pages/search-result/search-result.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { ModalComponent } from './pages/modal/modal.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule, MatDialogModule, MatIconModule, MatToolbarModule } from '@angular/material';
import { DatePipe } from '@angular/common';
import { ResultadoComponent } from './pages/resultado/resultado.component';

@NgModule({
  declarations: [
    AppComponent,
    SearchFormComponent,
    SearchResultComponent,
    ResultadoComponent,
    NavbarComponent,
    ModalComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    MatDialogModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    ReactiveFormsModule,
    RouterModule.forRoot(
      [
        // { path: 'pesquisa', component: SearchFormComponent },
        // { path: 'resultado-fichas', component: SearchResultComponent },
        { path: ':siglaMarca/resultado', component: ResultadoComponent },
        { path: '', redirectTo: 'FL/resultado', pathMatch: 'full' },
        { path: '**', redirectTo: 'FL/resultado', pathMatch: 'full' },
      ])
  ],
  providers: [
    DatePipe
  ],

  entryComponents: [
    ModalComponent
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
